export default {
  workspace: {
    connected: false,
  },
}
